// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1U8eq","title":"styles_title__IJSpJ","wrapper":"styles_wrapper__V8Kci","asside":"styles_asside__1iBp9","award":"styles_award__Fmbyp"};